import { Injectable } from '@angular/core';
import {  Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccountFilterStoreService {
  public nameFilter = new Subject<string>();
  public emailFilter = new Subject<string>();
  constructor() { }
}
